import React from "react";

const RichTextViewer = ({ content, className = "" }) => {
  if (!content) return null;

  // In iOS WebView, videos need playsinline + preload to display thumbnails
  let processedContent = content;
  if (window.isInApp) {
    processedContent = content.replace(/<video\b/gi, "<video playsinline webkit-playsinline preload=\"auto\"");
  }

  return (
    <div
      className={
        "tw-prose tw-prose-sm tw-max-w-none " +
        "[&_p]:tw-my-1.5 [&_ul]:tw-my-1.5 [&_ol]:tw-my-1.5 " +
        "[&_h2]:tw-text-lg [&_h2]:tw-font-semibold [&_h2]:tw-mt-4 [&_h2]:tw-mb-1.5 " +
        "[&_h3]:tw-text-base [&_h3]:tw-font-semibold [&_h3]:tw-mt-3 [&_h3]:tw-mb-1 " +
        "[&_blockquote]:tw-border-l-2 [&_blockquote]:tw-border-gray-300 [&_blockquote]:tw-pl-3 [&_blockquote]:tw-italic [&_blockquote]:tw-text-gray-500 " +
        "[&_ul]:tw-list-disc [&_ul]:tw-pl-5 [&_ol]:tw-list-decimal [&_ol]:tw-pl-5 " +
        "[&_strong]:tw-font-semibold [&_em]:tw-italic " +
        "[&_hr]:tw-my-4 [&_hr]:tw-border-gray-200 " +
        "[&_img]:tw-max-w-full [&_img]:tw-rounded-lg [&_img]:tw-my-2 " +
        "[&_video]:tw-max-w-full [&_video]:tw-rounded-lg [&_video]:tw-my-2 " +
        "[&_iframe]:tw-w-full [&_iframe]:tw-rounded-lg [&_iframe]:tw-my-2 [&_iframe]:tw-aspect-video " +
        "[&_div[data-youtube-video]]:tw-my-2 [&_div[data-youtube-video]_iframe]:tw-w-full [&_div[data-youtube-video]_iframe]:tw-aspect-video [&_div[data-youtube-video]_iframe]:tw-rounded-lg " +
        className
      }
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  );
};

export default RichTextViewer;
